export class ContractPdfModel {
    StoragePath: string;
    FullPath: string;
    PdfBody: string;
}